module.exports = __webpack_public_path__ + "img/frown_ios_802.png";